var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"title":"Données par catégories","loading":_vm.loading,"colors":_vm.colors,"series":_vm.series,"labels":_vm.labels,"yAxis":_vm.yAxis,"xAxis":_vm.xAxis,"stroke":_vm.stroke,"outlined":""}})}
var staticRenderFns = []

export { render, staticRenderFns }